import _isEmpty from "lodash/isEmpty";
import React, { useState, useEffect, useCallback } from "react";
import { withStyles } from "@mui/styles";

import { styles } from "../styles";
import { DatePanel } from "./DatePanel";
import { Chart } from "../../../components/Chart/index";
import { METRIC_TYPES } from "../../../constants/global";
import CurrentStatusCard from "../component/CurrentStatusCard";
import { NoResults } from "../../../components/BaseComponents/NoResults";
import { getUptimeMetrics, getRequestLatency } from "../../../api/metrics/index";
import { getDefaultBeforeDate, getPercentUptime, getAverageLatency } from "../../../helpers/metrics";

const DashboardItem = ({ classes, type, updateRequestLatency, updateCheckMetric }) => {
  const [metricsData, setMetricsData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const [beforeDate, setBeforeDate] = useState(getDefaultBeforeDate());
  const [afterDate, setAfterDate] = useState(Date.now());

  const fetchMetricsData = useCallback(
    async (type) => {
      try {
        if (type === METRIC_TYPES.CHECK_PASSED) {
          const data = await getUptimeMetrics({
            startTime: new Date(beforeDate),
            endTime: new Date(afterDate)
          });
          setMetricsData(data);
          updateCheckMetric(getPercentUptime(data).toFixed(2));
        } else {
          const data = await getRequestLatency({
            startTime: new Date(beforeDate),
            endTime: new Date(afterDate)
          });
          setMetricsData(data);
          updateRequestLatency(getAverageLatency(data).toFixed(2));
        }

        setIsLoading(false);
      } catch (e) {
        console.error(e);
        setIsLoading(false);
      }
    },
    [afterDate, beforeDate, updateCheckMetric, updateRequestLatency]
  );

  const setBeforeDateHandler = (date) => {
    setBeforeDate(date);
  };

  const setAfterDateHandler = (date) => {
    setAfterDate(date);
  };

  const fetchData = (type) => {
    setIsLoading(true);
    fetchMetricsData(type);
  };

  useEffect(() => {
    fetchMetricsData(type);
  }, [fetchMetricsData, type]);

  return (
    <div className={classes.healthWrapper}>
      <DatePanel
        startDate={beforeDate}
        endDate={afterDate}
        setBeforeDate={setBeforeDateHandler}
        setAfterDate={setAfterDateHandler}
        type={type}
        fetchData={fetchData}
      />
      {!isLoading && _isEmpty(metricsData) ? (
        <NoResults />
      ) : (
        <>
          <Chart chartData={metricsData} isLoading={isLoading} type={type} />
          {type === METRIC_TYPES.CHECK_PASSED && !isLoading && <CurrentStatusCard chartData={metricsData} />}
        </>
      )}
    </div>
  );
};

export default withStyles(styles)(DashboardItem);
